/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) No Ignition Icon component.
 */
export const NoIgnitionIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M14 10.5996V13H11.5811V11.1543H9.81348V9.40039H7.95312L7.69824 9.12988L10.1348 6.69238L14 10.5996Z' fill={iconColor} />
      <path d='M13.4297 2.88379L3.88379 12.4297L3 11.5459L12.5459 2L13.4297 2.88379Z' fill={iconColor} />
      <path fillRule='evenodd' clipRule='evenodd' d='M5.62793 1C7.6743 1.00001 9.25566 2.56904 9.25586 4.59961C9.25586 4.64903 9.25409 4.69884 9.25098 4.74805L5.80762 8.19141C5.74971 8.19614 5.69017 8.20019 5.62793 8.2002C3.58142 8.2002 2 6.63038 2 4.59961C2.0002 2.56903 3.58155 1 5.62793 1ZM4.97656 2.75391C4.32548 2.75401 3.76758 3.30801 3.76758 3.9541C3.76772 4.60009 4.32556 5.15419 4.97656 5.1543C5.62764 5.1543 6.18638 4.60015 6.18652 3.9541C6.18652 3.30795 5.62773 2.75391 4.97656 2.75391Z' fill={iconColor} />
    </svg>
  );
};

export default NoIgnitionIcon;
